import React, { useEffect, useState } from 'react';
import Button from 'react-myoneui/lib/Button';
import { ConfirmBox } from 'components/ConfirmBox';
import { userCreate } from 'api';
import { useDispatch } from 'react-redux';
// import ToastBox from 'components/ToastBox';
// import { setToastBoxStatus, setToastBoxDescription } from '../../../../../redux';
import { setAlertNotification } from '../../../../../redux';
import ls from 'localstorage-slim';
const CustomiseHeaderTemplate = ({ value, data, column, tableManager, onRowsRequest }) => {
  const [confirmBoxLoading, setConfirmBoxLoading] = useState(false);
  const [showConfirmBox, setShowConfirmBox] = useState(false);
  const dispatch = useDispatch();
  const {
    config: {
      additionalProps: { cell: additionalProps = {} },
    },
  } = tableManager;
  const parent_id = ls.get('parent_id');
  let classNames = ('rgt-text-truncate ' + (additionalProps.className || '')).trim();

  const updateStatus = async (status, reason = null) => {
    try {
      const payload = {
        id: data._id,
        parent_id: parent_id,
        // status: status,
        // reason: reason,
      };
      setConfirmBoxLoading(true);
      const result = await userCreate(payload);
      if (result.error) {
        // dispatch(setToastBoxStatus(true));
        // dispatch(setToastBoxDescription(result?.message));
        dispatch(
          setAlertNotification({
            msg: result?.data?.message,
            alertStatus: true,
            title: 'Success',
          }),
        );
      } else {
        // dispatch(setToastBoxStatus(true));
        // dispatch(setToastBoxDescription(result?.data?.message));
      }
      setConfirmBoxLoading(false);
      onRowsRequest();
      setShowConfirmBox(false);
      // setShowRejectConfirmBox(false);
    } catch (err) {
      setConfirmBoxLoading(false);
      dispatch(
        setAlertNotification({
          msg: err?.data?.message,
          alertStatus: false,
          title: 'Failed',
        }),
      );
    }
  };

  return (
    <>
      {/* <ToastBox /> */}
      {showConfirmBox && (
        <ConfirmBox
          show={showConfirmBox}
          question={`Are you sure you want to add to approve "${data?.full_name}" applicant? Once approved the applicant will be created as apprentice in the system.`}
          cancelText="Cancel"
          okText="Confirm"
          onHide={() => setShowConfirmBox(false)}
          onOk={() => updateStatus('approved')}
          loading={confirmBoxLoading}
        />
      )}

      {/* {showRejectConfirmBox && (
        <ConfirmBox
          show={showRejectConfirmBox}
          question={`Are you sure you want to Reject this applicant?`}
          cancelText="Cancel"
          okText="Confirm"
          applicantApplicationReject={true}
          onHide={() => setShowRejectConfirmBox(false)}
          onOk={(reason) => updateStatus('rejected', reason)}
          loading={confirmBoxLoading}
        />
      )} */}

      <div
        className="rgt-cell-inner rgt-text-truncate program-edit-hover justify-content-center"
        title={value}
      >
        {value?.toLowerCase() === 'assigned training provider' && (
          <>
            <div className="d-flex gap-2 m-1">
              <Button
                variant="white"
                className="btn-round"
                onClick={() => setShowConfirmBox(true)}
                type="button"
              >
                Approve
              </Button>
              {/* 
              <Button
                variant="white"
                className="btn-round"
                onClick={() => setShowRejectConfirmBox(true)}
                type="button"
              >
                Reject
              </Button> */}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default CustomiseHeaderTemplate;
